import { ISelectItem } from '@lla-platform/core/core-ui'

export enum DeclineReason {
  NotApplicable = 'NotApplicable',
  Price = 'Price',
  Schedule = 'Schedule',
  Location = 'Location',
  SecondOpinion = 'SecondOpinion',
  JustShopping = 'JustShopping',
  NoAvailabilityOffered = 'NoAvailabilityOffered',
  Other = 'Other'
}

export const DeclineReasonToLabel: Record<string, string> = {
  NotApplicable: 'Not applicable',
  Price: 'Price',
  Schedule: 'Schedule',
  Location: 'Location',
  SecondOpinion: 'Second opinion',
  JustShopping: 'Just shopping',
  NoAvailabilityOffered: 'No availability offered',
  Other: 'Other'
}

export const DeclineReasonItems: ISelectItem[] = Object.values(DeclineReason).map((value) => ({
  label: DeclineReasonToLabel[value],
  value
}))
